import React from 'react';
import Container from './Container.js';
import ServiceBenefitItem from './ServiceBenefitItem.js';
const ServiceBenefits = ({
  benefits = []
}) => /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("section", {
  className: "ebds-service-benefits"
}, benefits.map((benefit, index) => /*#__PURE__*/React.createElement(ServiceBenefitItem, {
  key: index,
  headline: benefit.fields.headline,
  description: benefit.fields.description,
  icon: benefit.fields.icon
}))));
export default ServiceBenefits;